<template>
  <div class="pi-obm">
    <div class="pi-table-wrap">
      <table class="pi-table pi-obm__table">
        <caption class="pi-sr">Marcos atingidos até D+15, D+30 e D+60, sobre as empresas com a janela fechada</caption>
        <thead>
        <tr>
          <pi-th v-for="column in headerColumns" :key="column.key" :column="column"/>
        </tr>
        </thead>
        <tbody v-for="group in groups" :key="group.key" class="pi-obm__group">
        <tr v-for="(row, index) in group.rows" :key="row.key">
          <th v-if="index === 0" scope="rowgroup" :rowspan="group.rows.length" class="pi-obm__group-name">{{ group.label }}</th>
          <th scope="row" class="pi-obm__name">
            {{ row.label }}
            <span v-if="row.bottleneck" class="pi-badge pi-badge--warn">⚠ {{ row.bottleneck }}</span>
          </th>
          <td v-for="cell in row.cells" :key="cell.key" class="pi-obm__cell" :class="{ 'is-on': isOn(row, cell) }">
            <button v-if="cell.clickable" type="button" class="pi-obm__btn" :style="cell.style" :title="cell.title"
                    :aria-label="cell.ariaLabel" :aria-pressed="isOn(row, cell) ? 'true' : 'false'"
                    @click="$emit('select', { milestone: row.key, window: cell.window })">
              <span class="pi-obm__value">{{ cell.text }}</span>
              <span v-if="cell.ratio" class="pi-obm__sub">{{ cell.ratio }}</span>
            </button>
            <span v-else class="pi-obm__static" :title="cell.title">{{ cell.text }}</span>
            <span v-if="cell.badge" class="pi-badge pi-badge--muted">{{ cell.badge }}</span>
            <span v-if="cell.delta" class="pi-obm__sub">{{ cell.delta }}</span>
            <span v-if="cell.notMeasuredText" class="pi-obm__sub pi-unmeasured">{{ cell.notMeasuredText }}</span>
          </td>
        </tr>
        </tbody>
        <tbody v-if="quantities.length" class="pi-obm__group">
        <tr v-for="(row, index) in quantities" :key="row.key">
          <th v-if="index === 0" scope="rowgroup" :rowspan="quantities.length" class="pi-obm__group-name">Quant.</th>
          <th scope="row" class="pi-obm__name">{{ row.label }}</th>
          <td v-for="cell in row.cells" :key="cell.key" class="is-num pi-obm__qty" :title="cell.title || null">{{ cell.text }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <ul v-if="notes.length" class="pi-obm__notes">
      <li v-for="note in notes" :key="note">{{ note }}</li>
    </ul>
  </div>
</template>

<script>
import piTh from "./piTh.vue";
import { screenColumns } from "./piColumns.js";
import { ONBOARDING_MATRIX_COLUMNS } from "./piOnboardingModel.js";

export default {
  name: "pi-onboarding-matrix",
  components: { piTh },
  props: {
    groups: { type: Array, default: () => [] },
    quantities: { type: Array, default: () => [] },
    notes: { type: Array, default: () => [] },
    selected: { type: Object, default: null },
  },
  computed: {
    headerColumns() {
      return screenColumns(ONBOARDING_MATRIX_COLUMNS);
    },
  },
  methods: {
    isOn(row, cell) {
      return !!this.selected && this.selected.milestone === row.key && this.selected.window === cell.window;
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-obm__table {
  border-collapse: separate;
  border-spacing: 0 2px;
}

.pi-obm__group + .pi-obm__group tr:first-child > * {
  border-top: 2px solid #e6e7eb;
}

.pi-obm__group-name {
  width: 70px;
  font-size: 11px;
  font-weight: 700;
  color: #4e5560;
  text-transform: uppercase;
  vertical-align: top;
}

.pi-obm__name {
  font-weight: 400;
  color: #1f2933;
}

.pi-obm__cell {
  min-width: 110px;
  padding: 2px 4px;
  text-align: right;
  white-space: nowrap;
}

.pi-obm__btn {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 96px;
  padding: 4px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  font: inherit;
  cursor: pointer;
}

.pi-obm__btn:hover,
.pi-obm__btn:focus {
  border-color: #1b59f8;
  outline: none;
}

.pi-obm__cell.is-on .pi-obm__btn {
  border-color: #1d12b9;
  box-shadow: 0 0 0 2px #1d12b9;
}

.pi-obm__value {
  font-weight: 700;
}

.pi-obm__sub {
  display: block;
  font-size: 11px;
  opacity: 0.85;
}

.pi-obm__static {
  color: #6b7280;
}

.pi-obm__qty {
  font-weight: 600;
  white-space: nowrap;
}

.pi-obm__notes {
  margin: 10px 0 0;
  padding-left: 18px;
  font-size: 12px;
  color: #4e5560;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piOnboardingMatrix.vue